import { Injectable } from '@angular/core';

import { Observable, Observer } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { ReplaySubject } from 'rxjs/';

import { CommunicationService } from './communication.service';
import { ProfileService } from './profile.service';
import { Authentication } from '../models/authentication';
import { User } from '../models/user';
import { BasicError, Error401 } from '../models/error/error';

@Injectable()

/**
 * This class controlls the login for this system.
 */
export class AuthenticationService {
  private loginPath: String = '/api/v1/auth/login';
  private refreshPath: String = '/api/v1/auth/refresh';

  constructor(private communication: CommunicationService, private profileService: ProfileService) {
  }

  /**
   * This function tries to log a specific user into the system.
   * @param username username of specific user
   * @param password password of specific user
   */
  public login(username: String, password: String): ReplaySubject<any> {
    // create json for transmission
    const datas = {
      'data': {
        'type': 'users',
        'attributes': {
          'email': username.toString(),
          'password': password.toString()
        }
      }
    };

    const returnSubject: ReplaySubject<any> = new ReplaySubject(1);

    // Calling authentication service of api
    const request = this.communication.post(this.loginPath, datas);
    request.subscribe(json => {
      if (json instanceof BasicError) {
        returnSubject.next(json);
        return;
      }

      const token = json.data.attributes.token;
      const authentication: Authentication = new Authentication(username, password, token);
      this.communication.setAuthentication(authentication);

      // Getting User
      this.profileService.getMyProfile(true).subscribe(user => {
        if (user instanceof BasicError) {
          returnSubject.next(null);
          return;
        }
        returnSubject.next(user)
      });
    });

    return returnSubject;
  }

  /**
   * This function tries to reuse a given token. If it fails it tries to login with the existing
   * authentication object of CommunicationService
   */
  public reuse(): ReplaySubject<any> {
    const reuseReplay: ReplaySubject<any> = new ReplaySubject(1);

    // Getting authentication object and check if username and password are available
    const auth: Authentication = this.communication.getAuthentication();
    let reauth: Boolean = false;

    if (auth !== undefined && auth !== null && auth.getUsername() !== undefined &&
      auth.getUsername().length > 2 && auth.getPassword() !== undefined && auth.getPassword().length > 2) {
      reauth = true;
    }

    // Getting User without login
    this.profileService.getMyProfile().subscribe(user => {
      if (user instanceof BasicError && !reauth) {
        reuseReplay.next(user);
        return;
      } else if (user instanceof BasicError && reauth) {
        // reauthentification is possible
        if (user instanceof Error401) {
          // reauth user
          this.login(auth.getUsername(), auth.getPassword()).subscribe(reuser => reuseReplay.next(reuser));
          return;
        } else {
          reuseReplay.next(user);
        }
      }
      reuseReplay.next(user)
    });

    return reuseReplay;
  }

  public refresh(): ReplaySubject<any> {
    const refreshReplay: ReplaySubject<any> = new ReplaySubject(1);

    const request = this.communication.get(this.refreshPath);
    request.subscribe(data => {
      if (data instanceof BasicError) {
        // Refreshing failed
        console.log('----------AuthenticationService---------: Failed to refresh token.');
        console.log(data);
        refreshReplay.next(false);
      } else {
        const token = data.data.attributes.token;
        const auth = this.communication.getAuthentication();
        auth.setToken(token);
        this.communication.setAuthentication(auth);
        refreshReplay.next(true);
      }
    });


    return refreshReplay;
  }

  /**
   * This function logs the current user out of the system and reloads the page
   */
  public logout(): void {
    this.communication.unsetAuthentication();
    location.reload();
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/services/authentication.service.ts